<template>
	<UPopover :open-delay="60" :close-delay="100" mode="hover">
		<slot name="activator" v-bind="{ props: {} }" />
		<template #content>
			<div class="overflow-hidden rounded border border-default bg-default">
				<slot />
			</div>
		</template>
	</UPopover>
</template>

<script setup lang="ts">
</script>
